// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BookCard Styles */

.book-card {
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--slate-100);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: all var(--transition-normal);
}

.book-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.book-card.book-borrowed {
  border-color: var(--borrowed-border);
}

.book-cover-wrapper {
  position: relative;
  aspect-ratio: 2 / 3;
  overflow: hidden;
  background-color: var(--slate-100);
}

.book-cover {
  width: 100%;
  height: 100%;
  position: relative;
}

.book-cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--transition-slow);
}

.book-card:hover .book-cover-image {
  transform: scale(1.05);
}

.book-cover-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--slate-100) 0%, var(--slate-200) 100%);
  color: var(--slate-400);
  padding: 1rem;
  text-align: center;
}

.book-cover-placeholder .material-symbols-outlined {
  font-size: 64px;
  opacity: 0.5;
}

/* Placeholder content with book title and author */
.book-cover-placeholder .placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}

.book-cover-placeholder .placeholder-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.book-cover-placeholder .placeholder-author {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-sub);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.book-status-badge {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1;
}

.badge-available,
.badge-borrowed {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: var(--radius-full);
  backdrop-filter: blur(8px);
  box-shadow: var(--shadow-sm);
}

.badge-available {
  background-color: rgba(220, 252, 231, 0.95);
  color: var(--success-text);
  border: 1px solid rgba(134, 239, 172, 0.5);
}

.badge-borrowed {
  background-color: rgba(254, 226, 226, 0.95);
  color: var(--borrowed-text);
  border: 1px solid rgba(252, 165, 165, 0.5);
}

.badge-available .material-symbols-outlined,
.badge-borrowed .material-symbols-outlined {
  font-size: 14px;
}

.book-info {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.book-category-label {
  font-size: 0.625rem;
  font-weight: 700;
  color: var(--primary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.25rem;
}

.book-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.3;
  margin-bottom: 0.25rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.book-shelf {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin: 0 0 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--primary);
}

.book-shelf .material-symbols-outlined {
  font-size: 14px;
}

.book-author {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin-bottom: 0.75rem;
}

.book-meta {
  margin-top: auto;
  padding-top: 0.75rem;
  border-top: 1px solid var(--slate-100);
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.book-category,
.book-isbn,
.book-publisher {
  font-size: 0.625rem;
  color: var(--slate-400);
}

/* Borrower Details */
.borrower-details {
  padding: 1rem;
  background-color: var(--borrowed-bg);
  border-top: 1px solid var(--borrowed-border);
  font-size: 0.75rem;
}

.borrower-details p {
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  color: var(--borrowed-text);
}

.borrower-details p:last-child {
  margin-bottom: 0;
}

.borrower-details strong {
  font-weight: 600;
  color: var(--borrowed-text);
}

/* Responsive */
@media (max-width: 768px) {
  .book-card {
    border-radius: var(--radius-lg);
  }

  .book-title {
    font-size: 1rem;
  }

  .book-info {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/public/BookCard.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+EAA+E;EAC/E,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,oCAAoC;EACpC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* BookCard Styles */\n\n.book-card {\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--slate-100);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  transition: all var(--transition-normal);\n}\n\n.book-card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.book-card.book-borrowed {\n  border-color: var(--borrowed-border);\n}\n\n.book-cover-wrapper {\n  position: relative;\n  aspect-ratio: 2 / 3;\n  overflow: hidden;\n  background-color: var(--slate-100);\n}\n\n.book-cover {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.book-cover-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform var(--transition-slow);\n}\n\n.book-card:hover .book-cover-image {\n  transform: scale(1.05);\n}\n\n.book-cover-placeholder {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--slate-100) 0%, var(--slate-200) 100%);\n  color: var(--slate-400);\n  padding: 1rem;\n  text-align: center;\n}\n\n.book-cover-placeholder .material-symbols-outlined {\n  font-size: 64px;\n  opacity: 0.5;\n}\n\n/* Placeholder content with book title and author */\n.book-cover-placeholder .placeholder-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.book-cover-placeholder .placeholder-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-main);\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.book-cover-placeholder .placeholder-author {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--text-sub);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n\n.book-status-badge {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 1;\n}\n\n.badge-available,\n.badge-borrowed {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: var(--radius-full);\n  backdrop-filter: blur(8px);\n  box-shadow: var(--shadow-sm);\n}\n\n.badge-available {\n  background-color: rgba(220, 252, 231, 0.95);\n  color: var(--success-text);\n  border: 1px solid rgba(134, 239, 172, 0.5);\n}\n\n.badge-borrowed {\n  background-color: rgba(254, 226, 226, 0.95);\n  color: var(--borrowed-text);\n  border: 1px solid rgba(252, 165, 165, 0.5);\n}\n\n.badge-available .material-symbols-outlined,\n.badge-borrowed .material-symbols-outlined {\n  font-size: 14px;\n}\n\n.book-info {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.book-category-label {\n  font-size: 0.625rem;\n  font-weight: 700;\n  color: var(--primary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.25rem;\n}\n\n.book-title {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--text-main);\n  line-height: 1.3;\n  margin-bottom: 0.25rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.book-shelf {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin: 0 0 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.book-shelf .material-symbols-outlined {\n  font-size: 14px;\n}\n\n.book-author {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin-bottom: 0.75rem;\n}\n\n.book-meta {\n  margin-top: auto;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--slate-100);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.book-category,\n.book-isbn,\n.book-publisher {\n  font-size: 0.625rem;\n  color: var(--slate-400);\n}\n\n/* Borrower Details */\n.borrower-details {\n  padding: 1rem;\n  background-color: var(--borrowed-bg);\n  border-top: 1px solid var(--borrowed-border);\n  font-size: 0.75rem;\n}\n\n.borrower-details p {\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--borrowed-text);\n}\n\n.borrower-details p:last-child {\n  margin-bottom: 0;\n}\n\n.borrower-details strong {\n  font-weight: 600;\n  color: var(--borrowed-text);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .book-card {\n    border-radius: var(--radius-lg);\n  }\n\n  .book-title {\n    font-size: 1rem;\n  }\n\n  .book-info {\n    padding: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
